import ExportExcelBox from './src/main'

/* istanbul ignore next */
ExportExcelBox.install = function (Vue) {
  Vue.component(ExportExcelBox.name, ExportExcelBox)
}

export default ExportExcelBox



// WEBPACK FOOTER //
// ./core/components/ExportExcelBox/index.js